import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { ItemPriceComponentStore, defaultItemPricingModel } from 'products-data';
import { CommonItemComponentBase } from '../../CommonItemComponentBase';
import { ProductFeesViewComponent } from './views/product-fees-view/product-fees-view.component';

@Component({
  selector: 'ideal-product-fees',
  imports: [ProductFeesViewComponent],
  standalone: true,
  templateUrl: './product-fees.component.html',
  styleUrl: './product-fees.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ItemPriceComponentStore],
})
export class ProductFeesComponent extends CommonItemComponentBase {
  public readonly multiplyBy = input(1);

  private readonly _feesStore = inject(ItemPriceComponentStore);
  protected readonly pricing = computed(() => this._feesStore.itemPricing()?.pricing ?? defaultItemPricingModel);
  protected readonly feesLoading = this._feesStore.itemPricing.loading;
  protected readonly feesError = this._feesStore.itemPricing.error;
  protected readonly feesSuccess = computed(() => !this._feesStore.itemPricing.error() && !!this._feesStore.itemPricing());
  protected readonly ready = computed(() => this.feesSuccess() && !this.feesLoading());

  constructor() {
    super();
    effect(() => this._feesStore.selectItemById(this.itemId()));
  }
}
